import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=277fb3e6&scoped=true"
import script from "./RegionList.vue?vue&type=script&lang=ts"
export * from "./RegionList.vue?vue&type=script&lang=ts"
import style0 from "./RegionList.vue?vue&type=style&index=0&id=277fb3e6&prod&lang=scss&scoped=true"
import style1 from "./RegionList.vue?vue&type=style&index=1&id=277fb3e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277fb3e6",
  null
  
)

export default component.exports